window.get_discount =  '';
async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error(`Cart failed: ${response.status}`);
      const cart = await response.json();
      return cart;
    } catch (err) {
      console.error("Cart.js error:", err);
      return null;
    }
  }

  async function fetchDiscount(discountCode) {
    try {
      const response = await fetch(
        'https://integrations.playermaker.co.uk/webhook/pm-discount-data',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: discountCode })
        }
      );
      const data = await response.json();
      return data;
    } catch (err) {
      console.error("Discount webhook error:", err);
      return null;
    }
  }

document.addEventListener("DOMContentLoaded", async () => {
    try {
      const cartData = await fetchCart();
      if (!cartData) return;

      const discountObj = cartData.discount_codes?.[0];

      if (!discountObj) {
        return;
      }

      const discountCode = discountObj.code;
      const response = await fetchDiscount(discountCode);
      const discountAmount = response?.discount?.[0]?.discount?.customerGets?.value?.amount?.amount;
      
     
      if (discountAmount) {
       
        const els = document.querySelectorAll(".cart_discount_main");
        els.forEach(el => {
          el.classList.add("flex-discount");
        });
 

        const el = document.querySelector(".select-membership-cart-discount-main");
        const cartDiscount = document.querySelector(".select-membership-cart-discount_update");
        const discountEl = el.querySelector('.discount_value');
        const discountCents = Math.round(parseFloat(discountAmount) * 100);

        const rate = (Shopify.currency && Shopify.currency.rate) ? Shopify.currency.rate : 1;
        const convertedDiscountCents = Math.round(discountCents * rate);
        let roundedCents = Math.round(convertedDiscountCents / 100) * 100;
        window.get_discount =  roundedCents;
        
        let price = Shopify.formatMoney(roundedCents, window.Money_Filter);
        discountEl.innerHTML = price.replace(',00', '').replace('.00', '');
        if(cartDiscount !== null){
          cartDiscount.innerHTML = price.replace(',00', '').replace('.00', '');
        }
        const priceEls = document.querySelectorAll('.price_main_product_discount');
        priceEls.forEach(priceEl => {
          const originalCents = parseInt(priceEl.dataset.price, 10);
          const baseDiscountCents = Math.round(parseFloat(discountAmount) * 100);
          const discountCents = Math.round(baseDiscountCents * (Shopify?.currency?.rate || 1));
          const finalCents = Math.max(0, originalCents - discountCents);
          console.debug(finalCents,'finalCentsfinalCents')
          // 🔥 Round to nearest whole currency unit
          const roundedFinalCents = Math.round(finalCents / 100) * 100;

          priceEl.dataset.discount = discountCents;

          const formattedPrice = Shopify.formatMoney(
            roundedFinalCents,
            window.Money_Filter
          );

          priceEl.innerHTML = formattedPrice.replace(',00', '').replace('.00', '');
        });
        
      }

      const discountPercentage = response?.discount?.[0]?.discount?.customerGets?.value.percentage;
      if (discountPercentage) {
        const cartDiscount = document.querySelector(".select-membership-cart-discount_update");
         if(cartDiscount !== null){
          cartDiscount.innerHTML = discountPercentage *100+ '%';
        }
        const els = document.querySelectorAll(".cart_discount_main");
        els.forEach(el => el.classList.add("flex-discount"));

        const discountWrap = document.querySelector(".select-membership-cart-discount-main");
        const discountEl = discountWrap?.querySelector('.discount_value');
        var get_discount = discountPercentage*100;
        discountEl.innerHTML =  get_discount + '%';
         window.get_discount =  get_discount + '%';
        const priceEls = document.querySelectorAll('.price_main_product_discount');
        if (!priceEls.length) return;

        priceEls.forEach(priceEl => {
          const originalCents = parseInt(priceEl.dataset.price, 10);
          if (isNaN(originalCents)) return;

          const discountCents = Math.round(originalCents * discountPercentage);
          const finalCents = Math.max(0, originalCents - discountCents);

          priceEl.dataset.discount = discountCents;

          // 👉 Round to whole currency (remove cents)
          const roundedCents = Math.round(finalCents / 100) * 100;

          const formattedPrice = Shopify.formatMoney(
            roundedCents,
            window.Money_Filter
          );

          priceEl.innerHTML = formattedPrice.replace('.00','').replace(',00','');
        });
      }
      
    } catch (err) {
      console.error("Page error:", err);
    }
});

